<template>
  <ThemeProvider theme="campsite">
    <div id="outer-container">
      <Svgs />
      <Header />
      <main id="main">
        <nuxt />
      </main>
      <Footer />
    </div>
  </ThemeProvider>
</template>

<script>
import { ThemeProvider } from '@campsite-bio/component-lib';
import { useRoute } from '@nuxtjs/composition-api';
import Cookies from 'cookies-js';

import Header from '@/components/header';
import Footer from '@/components/footer/footer';
const Svgs = () => import('@/components/svgs');
import intercom from '~/plugins/intercom';
import fbPixel from '~/plugins/facebook-pixel';

export default {
  components: {
    Header,
    Footer,
    Svgs,
    ThemeProvider,
  },

  setup() {
    const route = useRoute();

    // Set a cookie when a user comes from a profile page
    if (process.client && route.value.query.ref) {
      Cookies.set(
        'campsite_user_ref',

        JSON.stringify({
          username: route.value.query.ref,
          referrer: route.value.query.referrer,
        }),
        { domain: '.campsite.bio', expires: 7 * 24 * 60 * 60 },
      );
    }
  },

  created() {
    setTimeout(() => {
      intercom(this.$nuxt.context);
      fbPixel(this.$nuxt.context, {
        id: '337383080134581',
      });
    }, 1500);
  },

  head() {
    return {
      link: [
        {
          rel: 'canonical',
          href: 'https://campsite.bio' + this.$route.path,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
